import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '@/services/api';
import toast from 'react-hot-toast';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error('Please enter your email address');
      return;
    }

    setLoading(true);
    try {
      await authAPI.forgotPassword({ email: email.trim() });
      setSent(true);
              toast.success('Check your email for a reset link. It may take a few minutes.');

    } catch (err) {
      toast.error(err?.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-emerald-50/30 to-teal-50/20 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl p-8 lg:p-10">
        <div className="mb-8 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-r from-emerald-600 to-emerald-700 text-white">
            <i className="fas fa-key text-xl" />
          </div>
          <h2 className="text-2xl font-black text-slate-800">Forgot Password?</h2>
          <p className="mt-2 text-slate-500">Enter your email and we'll send you a reset link.</p>
        </div>

        {sent ? (
          <div className="text-center">
            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-emerald-100 text-emerald-600">
              <i className="fas fa-check text-2xl" />
            </div>
            <p className="text-slate-700 mb-6">
              Check your email for a reset link. If you don't receive anything, make sure you entered the correct email or contact the school.
            </p>

            <Link
              to="/auth/student-login"
              className="inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-emerald-600 to-emerald-700 px-6 py-3 font-semibold text-white shadow-lg transition hover:opacity-95"
            >
              <i className="fas fa-arrow-left" />
              Back to Login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-2">Email Address</label>
              <div className="relative">
                <i className="fas fa-envelope absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  className="w-full pl-11 pr-4 py-3.5 rounded-xl border-2 border-slate-200 focus:border-emerald-500 focus:ring-4 focus:ring-emerald-100 transition-all outline-none text-slate-800"
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-emerald-600 to-emerald-700 text-white py-3.5 rounded-xl font-bold shadow-lg shadow-emerald-200 hover:shadow-xl hover:-translate-y-0.5 transition-all disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-3"
            >
              {loading ? (
                <>
                  <i className="fas fa-circle-notch fa-spin" />
                  Sending...
                </>
              ) : (
                <>
                  <i className="fas fa-paper-plane" />
                  Send Reset Link
                </>
              )}
            </button>

            <div className="text-center pt-2">
              <Link to="/auth/student-login" className="text-sm font-medium text-emerald-600 hover:text-emerald-700 transition-colors">
                <i className="fas fa-arrow-left mr-1" /> Back to Login
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;

